module.exports = __webpack_public_path__ + "afb93908e13b32b9115ed3e9f0417b0e.pdf";